import { useEffect, useRef, useState } from "react";
import { WS_URL } from "@/lib/api";

export function useEngineSocket() {
  const [snapshot, setSnapshot] = useState(null);
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const retryRef = useRef(null);

  useEffect(() => {
    let mounted = true;

    const connect = () => {
      try {
        const ws = new WebSocket(WS_URL);
        wsRef.current = ws;
        ws.onopen = () => mounted && setConnected(true);
        ws.onmessage = (e) => {
          if (!mounted) return;
          try {
            setSnapshot(JSON.parse(e.data));
          } catch (_) {}
        };
        ws.onclose = () => {
          if (!mounted) return;
          setConnected(false);
          retryRef.current = setTimeout(connect, 2000);
        };
        ws.onerror = () => ws.close();
      } catch (_) {
        retryRef.current = setTimeout(connect, 2000);
      }
    };

    connect();
    return () => {
      mounted = false;
      clearTimeout(retryRef.current);
      wsRef.current && wsRef.current.close();
    };
  }, []);

  return { snapshot, connected };
}
